import {
  HttpEvent,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { DOCUMENT, inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { AuthHttpConfig } from "./auth-http-config";
import { ReturnUrlService } from "./return-url.service";
import { TokenRefreshService } from "./token-refresh.service";
import { NotifyService } from "../../notify/notify.service";
import { TOAST } from "../../notify/toast/toast-type.enum";

export const unauthorizedInterceptor: HttpInterceptorFn = (request, next) => {
  const httpConfig = inject(AuthHttpConfig);
  const returnUrlService = inject(ReturnUrlService);
  const notifyService = inject(NotifyService);
  const tokenRefreshService = inject(TokenRefreshService);
  const document = inject(DOCUMENT);

  const isOnLoginPage = () => document.location.href.indexOf("login") !== -1;

  const signOut = () => {
    returnUrlService.capture(
      document.location.pathname + document.location.search,
    );
    document.location.href = "/login";
    httpConfig.removeToken();
    httpConfig.removeRefreshToken();
  };

  const send = (
    req: HttpRequest<unknown>,
    canRefresh: boolean,
  ): Observable<HttpEvent<unknown>> =>
    next(req).pipe(
      catchError((error) => {
        if (
          error.status === 401 &&
          canRefresh &&
          httpConfig.getRefreshToken() &&
          !isOnLoginPage()
        ) {
          return tokenRefreshService.refresh().pipe(
            catchError(() => {
              signOut();

              return throwError(error);
            }),
            switchMap((token) =>
              send(
                req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
                false,
              ),
            ),
          );
        }

        if (
          (error.status === 401 || error.status === 402) &&
          !isOnLoginPage()
        ) {
          signOut();
        } else if (error.status === 403) {
          notifyService.toast(
            TOAST.ERROR,
            "You don't have sufficient permissions to perform this action",
          );
        }

        return throwError(error);
      }),
    );

  return send(request, true);
};
